module.exports = __webpack_public_path__ + "static/media/ImgMBTI_SOIC.36945e8c.png";